import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import PageContainer from './containers/PageContainer';
import QuickViewProvider from '../../components/QuickView';

import { rootNode, initParams, defaultState } from './configs';
import reducer from './reducers';
import createStore from '../../store/create-store';

const store = createStore(reducer, defaultState);
const { permissions } = initParams;

const PublisherShow = () => (
  <Provider store={store}>
    <QuickViewProvider permissions={permissions}>
      <PageContainer />
    </QuickViewProvider>
  </Provider>
);

document.addEventListener('DOMContentLoaded', () => {
  if (!rootNode) return;

  const root = createRoot(rootNode);
  root.render(<PublisherShow />);
});
